import React from 'react';
import { rangeUtil } from '@grafana/data';
import { RefreshPicker } from '@grafana/ui';
import { SceneObjectBase } from '../core/SceneObjectBase.js';
import { sceneGraph } from '../core/sceneGraph/index.js';
import { SceneObjectUrlSyncConfig } from '../services/SceneObjectUrlSyncConfig.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DEFAULT_INTERVALS = ["5s", "10s", "30s", "1m", "5m", "15m", "30m", "1h", "2h", "1d"];
class SceneRefreshPicker extends SceneObjectBase {
  constructor(state) {
    var _a;
    super(__spreadProps(__spreadValues({
      refresh: ""
    }, state), {
      intervals: (_a = state.intervals) != null ? _a : DEFAULT_INTERVALS
    }));
    this._urlSync = new SceneObjectUrlSyncConfig(this, { keys: ["refresh"] });
    this.onRefresh = () => {
      const timeRange = sceneGraph.getTimeRange(this);
      if (this._intervalTimer) {
        clearInterval(this._intervalTimer);
      }
      timeRange.onRefresh();
      this.setupIntervalTimer();
    };
    this.onIntervalChanged = (interval) => {
      this.setState({ refresh: interval });
      this.setupIntervalTimer();
    };
    this.setupIntervalTimer = () => {
      const timeRange = sceneGraph.getTimeRange(this);
      const { refresh, intervals } = this.state;
      if (this._intervalTimer || refresh === "") {
        clearInterval(this._intervalTimer);
      }
      if (refresh === "") {
        return;
      }
      if (intervals && !intervals.includes(refresh)) {
        return;
      }
      const intervalMs = rangeUtil.intervalToMs(refresh);
      this._intervalTimer = setInterval(() => {
        timeRange.onRefresh();
      }, intervalMs);
    };
    this.addActivationHandler(() => {
      this.setupIntervalTimer();
      return () => {
        if (this._intervalTimer) {
          clearInterval(this._intervalTimer);
        }
      };
    });
  }
  getUrlState() {
    return {
      refresh: this.state.refresh
    };
  }
  updateFromUrl(values) {
    const refresh = values.refresh;
    if (refresh && typeof refresh === "string") {
      this.setState({
        refresh
      });
    }
  }
}
SceneRefreshPicker.Component = SceneRefreshPickerRenderer;
function SceneRefreshPickerRenderer({ model }) {
  const { refresh, intervals, isOnCanvas } = model.useState();
  return /* @__PURE__ */ React.createElement(RefreshPicker, {
    value: refresh,
    intervals,
    onRefresh: model.onRefresh,
    onIntervalChanged: model.onIntervalChanged,
    isOnCanvas: isOnCanvas != null ? isOnCanvas : true
  });
}

export { DEFAULT_INTERVALS, SceneRefreshPicker, SceneRefreshPickerRenderer };
//# sourceMappingURL=SceneRefreshPicker.js.map
